import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';

interface CommentCardProps {
  avatarSrc: string;
  username: string;
  timeAgo: string;
  comment: string;
}

const CommentCard: React.FC<CommentCardProps> = ({ avatarSrc, username, timeAgo, comment }) => {
  return (
    <Box display="flex" mb={3}>
      <Avatar src={avatarSrc} alt={username} sx={{ width: 40, height: 40, mr: 2 }} />
      <Box>
        <Box display="flex" gap={1} alignItems="center">
          <Typography variant="subtitle2" fontWeight={600}>
            {username}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            · {timeAgo}
          </Typography>
        </Box>
        <Typography variant="body2" mt={0.5}>
          {comment}
        </Typography>
      </Box>
    </Box>
  );
};

export default CommentCard;
